<div style="width: 300px; margin-bottom: 25px">
    <app-other-components-component-type #componentType></app-other-components-component-type>
</div>
<button type="button" (click)="showAncillaryProductDialog()" class="btn btn-default btn-search">{{
    'OtherProducts.Button.ShowAncillaryProduct' | translate }}</button>
